import React from 'react';

interface FeatureToggleInformationProps {
  text: string;
}

export default function FeatureToggleInformation({ text }: FeatureToggleInformationProps) {
  return <p className='text-xs italic text-caption'>{text}</p>;
}
